

    <!-- <div  [ngClass]="{'container': panelOpenState == false, 'container-expanded': panelOpenState == true}">
       
    </div> -->
    <mat-accordion *ngIf = 'this.role == "Admin"'class="container-accordion" multi >
        <mat-expansion-panel *ngFor="let item of adminmenuOptions ;"
        class="expansion-panel" 
          [expanded] = "item"
        >
          <mat-expansion-panel-header  >
      <mat-panel-title >
        <div style = "font-weight: 500;">
      
         {{item.title}} 
        </div>
      </mat-panel-title>
      
          </mat-expansion-panel-header>
          <ng-container *ngFor="let subItem of item.subItems" >
      
            <div class="submenu" >
              <!-- <a style = "color: black" href="{{ subItem.path }}">{{ subItem.name }}</a> -->
              
              <!-- <a class="list-group-item list-group-item-action" [routerLinkActive]='["active"]' [routerLink]='["/{{subItem.path}}"]'>{{ subItem.name }}</a> -->
              <a style = "color: black" class="routerlink" href="{{subItem.path}}">{{subItem.name }}</a>

            </div>
      
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
  
      <mat-accordion *ngIf = 'this.role != "Admin"'class="container-accordion" multi >
        <mat-expansion-panel *ngFor="let item of usermenuOptions ;"
        class="expansion-panel" 
          [expanded] = "item"
        >
          <mat-expansion-panel-header  >
      <mat-panel-title >
        <div style = "font-weight: 500;">
      
         {{item.title}} 
        </div>
      </mat-panel-title>
      
          </mat-expansion-panel-header>
          <ng-container *ngFor="let subItem of item.subItems" >
      
            <div class="submenu" >
              <!-- <a style = "color: black" href="{{ subItem.path }}">{{ subItem.name }}</a> -->
              
              <!-- <a class="list-group-item list-group-item-action" [routerLinkActive]='["active"]' [routerLink]='["/{{subItem.path}}"]'>{{ subItem.name }}</a> -->
              <a style = "color: black" class="routerlink" href="{{subItem.path}}">{{subItem.name }}</a>

            </div>
      
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
     

      
